import { Modal } from './Modal'

interface ConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmLabel?: string
  isPending?: boolean
}

export function ConfirmDialog({
  open, onClose, onConfirm, title, message, confirmLabel = 'Удалить', isPending,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} onClose={onClose} title={title}>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-5 leading-relaxed break-words">
        {message}
      </p>
      <div className="flex justify-end gap-3">
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300
            hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
        >
          Отмена
        </button>
        <button
          onClick={onConfirm}
          disabled={isPending}
          className="px-4 py-2 text-sm font-medium rounded-lg bg-red-600 hover:bg-red-700
            disabled:opacity-50 text-white transition-colors"
        >
          {isPending ? 'Подождите...' : confirmLabel}
        </button>
      </div>
    </Modal>
  )
}
